import { BiPermission, PipelinePermission } from "../../permission";
import { IdentityProviderRoles } from "../models";

export function getRolesForNoneProvider(): IdentityProviderRoles {
    return {
        kdRoles: [...Object.values(BiPermission)],
        keRoles: [...Object.values(PipelinePermission)]
    };
}